module.exports = __webpack_public_path__ + "static/media/browserwindow.6c79697c.svg";